// extracted by mini-css-extract-plugin
export default {"image":"style_image__R8BNv","primaryImg":"style_primaryImg__q0OVz"};